import React from "react";
import { jwtDecode } from "jwt-decode";
import { Navigate, useLocation } from "react-router-dom";

import { clearAuthSession, getAuthToken } from "services/storage";

const PrivateRoute = ({ children }) => {
  const token = getAuthToken();
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  try {
    const decoded = jwtDecode(token);
    if (decoded?.exp && decoded.exp * 1000 <= Date.now()) {
      clearAuthSession();
      return <Navigate to="/login" replace state={{ sessionExpired: true }} />;
    }
  } catch {
    // Some deployments may use an opaque token. The API remains the authority.
  }

  return children;
};

export default PrivateRoute;
